<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
          <div slot="header">
              <i class="cui-file"></i> Contratos
              <b-link :to="`/${actionUri}/new/`" class="btn mr-2 btn-sm btn-primary float-right">
              <i class="fa fa-plus"></i>
                Entrada
              </b-link>
          </div>
          <b-card-body>
            <div class="form-row justify-content-start">
              <div class="col-md-6">
                <base-input label="Digite o nome do contrato" v-model="searchOptions.keywords" v-on:keyup.enter="searchOptions.keywords" placeholder="" />
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="">Status</label>
                  <select v-model="searchOptions.status" class="custom-select ml-1"><!--multiple="multiple"-->
                    <option :value="null">Todos</option>
                    <option :value="'Active'">Ativo</option>
                    <option :value="'Inactive'">Inativo</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-row justify-content-start">
              <div class="col-md-2">
                <b-button @click="search" variant="primary">Buscar</b-button>
              </div>
            </div>              
          </b-card-body>
        </b-card>
        <b-card>
          <b-row>
            <b-col lg="12">
              <c-table @onPageIndexChanged="onPageIndexChanged" :table-data="result" :actionUri="actionUri" :loading="loading" :fields="fields" striped></c-table>
            </b-col>
          </b-row>
        </b-card>
    </div>
</template>
<script>
import cTable from '../../../components/base/Table.vue'
import domainService from '../../../services/Contracts/contractService'
import listPage from '../../../mixins/listPage';
export default {
  components: {cTable},
  mixins: [listPage],
  data() {
    return {
      actionUri: 'partners/contracts',
      searchOptions: {
        keywords: '',
        status: null
      },
      fields: [
        {key: 'name', label: 'Nome', sortable: false},
        {key: 'status', label: 'Status', sortable: false},
        {key: 'automaticWithdrawal', label: 'Repasse automatico?', sortable: false},
        {key: 'createdAt', label: 'Criado em', sortable: false},
        {key: 'updatedAt', label: 'Atualizado em', sortable: false},
        {key: 'actions', label: ''}
      ]
    }
  },
  methods: {
    fetchData(page) {
        const self = this
        self.showLoading()
        domainService.findAll(this.searchOptions, page).then((response) =>{
            self.$data.result = response.status == 204 ? self.getEmptyResult() : response.data
            self.hideLoading()
        }, () =>{
            self.hideLoading()
        })
    }
  }
}
</script>
